import columns from "../../../../../react-table/helpers/columns";
import { showTotalProp } from "../../../../../react-table/helpers/rowTotals";
import ReportDefinitions from "../../../../../common/config/ReportDefinitions";

export const getCarrierTabNavigationProps =
  (originExchangeOfficesData) => (rowInfo) =>
    rowInfo && rowInfo.row
      ? {
          reportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_LOCATION.id,
          mainReportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_CARRIER.id,
          requestParams: {
            carrierCode: rowInfo.row["carrier"], // eslint-disable-line
            originExchangeOffices:
              originExchangeOfficesData.originExchangeOffices,
          },
          selectionCriteriaOptions: {
            includeSelectionCriteria: true,
          },
          reportsToBeCleared: [
            ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_DETAILS.id,
          ],
        }
      : {};

const splitData = (data) => {
  return data.reduce(
    (acc, row) => {
      if (row.carrier && row.carrier.toLowerCase() === "total") {
        acc.totalRow = row;
      } else {
        acc.dataRows.push(row);
      }
      return acc;
    },
    {
      totalRow: undefined,
      dataRows: [],
    }
  );
};

export default (data, originExchangeOfficesData) => {
  const { totalRow, dataRows } = splitData(data);

  const {
    TextColumn,
    NavigationWithFooterColumn,
    NumberColumn,
    PercentageColumn,
  } = columns(dataRows);

  return [
    {
      Header: "",
      columns: [
        new TextColumn("Carrier", "carrier").withTotalHeader(
          "Total",
          "bg-total-grey"
        ),
      ],
    },
    {
      Header: "Receptacles",
      columns: [
        new NavigationWithFooterColumn(
          new NumberColumn("Total", "receptacles.total").withTotalHeader(
            showTotalProp(totalRow, "receptacles.total"),
            "bg-total-grey"
          ),
          getCarrierTabNavigationProps(originExchangeOfficesData)
        ),
        new NumberColumn("LHOT origin", "receptacles.lhotOrigin").withShow(
          false
        ),
        new NumberColumn(
          "LHOT destination",
          "receptacles.lhotDestination"
        ).withShow(false),
        new NumberColumn(
          "Contract reference",
          "receptacles.contractReference"
        ).withShow(false),
        new NumberColumn(
          "Booking reference",
          "receptacles.bookingReference"
        ).withShow(false),
        new PercentageColumn(
          "% LHOT origin",
          "receptacles.pctLhotOrigin"
        ).withTotalHeader(
          showTotalProp(totalRow, "receptacles.pctLhotOrigin", true),
          "bg-total-grey"
        ),
        new PercentageColumn(
          "% LHOT destination",
          "receptacles.pctLhotDestination"
        ).withTotalHeader(
          showTotalProp(totalRow, "receptacles.pctLhotDestination", true),
          "bg-total-grey"
        ),
        new PercentageColumn(
          "% Contract reference",
          "receptacles.pctContractReference"
        ).withTotalHeader(
          showTotalProp(totalRow, "receptacles.pctContractReference", true),
          "bg-total-grey"
        ),
        new PercentageColumn(
          "% Booking reference",
          "receptacles.pctBookingReference"
        ).withTotalHeader(
          showTotalProp(totalRow, "receptacles.pctBookingReference", true),
          "bg-total-grey"
        ),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_LOCATION.id,
        mainReportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_CARRIER.id,
        requestParams: {
          isTotal: true,
          carrierCode: "*",
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
